import React, { useState } from "react";
import { Sidebar } from "./Sidebar";

const App = () => {
  const [, setUploadedImage] = useState(null);
  const [processedImage, setProcessedImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];

    // Read the uploaded file as a data URL
    const reader = new FileReader();
    reader.onloadend = () => {
      setUploadedImage(reader.result);
    };
    reader.readAsDataURL(selectedFile);

    const formData = new FormData();
    formData.append("file", selectedFile);

    setLoading(true);

    try {
      const response = await fetch(
        "https://api.techshoor.com/plant_health_report",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        // File uploaded successfully

        // Process the response as binary data
        const responseData = await response.arrayBuffer();

        // Convert the binary data to a Blob object
        const blob = new Blob([responseData], { type: "image/tiff" });

        // Create an object URL from the Blob
        const imageUrl = URL.createObjectURL(blob);

        // Set the processed image URL
        setProcessedImage(imageUrl);
      } else {
        // Handle upload error
        console.error("Upload failed");
      }
    } catch (error) {
      // Handle network or server error
      console.error("Error:", error);
    }

    setLoading(false);
  };

  return (
    <>
      <Sidebar />
      <div id="content" className="processed-image">
        <div className="single-input-group">
          <input
            type="file"
            accept=".tif"
            id="single-image-input"
            onChange={handleFileChange}
          />
          <label htmlFor="single-image-input" className="custom-file-upload">
            Upload Image
          </label>
        </div>
        <button
          type="submit"
          className="signle-btn-submit"
          hidden={true}
          disabled={!processedImage || loading}
        ></button>
        {loading && (
          <div>
            <h1 style={{ textAlign: "center" }}>Processing...</h1>
          </div>
        )}

        {processedImage && (
          <div className="processed-image">
            <img
              src={processedImage}
              alt="Processed"
              id="processed-image"
              width={"700px"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default App;
